import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Home, GraduationCap, RotateCcw, ScrollText, Phone } from "lucide-react";

const ITEMS = [
  { id: "inicio", label: "Inicio", icon: Home, to: "/", match: (p) => p === "/" },
  { id: "permisos", label: "Permisos", icon: GraduationCap, to: "/permisos", match: (p) => p.startsWith("/permisos") },
  { id: "puntos", label: "Puntos", icon: RotateCcw, to: "/recuperacion-de-puntos-vigo", match: (p) => p.startsWith("/recuperacion") || p.startsWith("/puntos") },
  { id: "test", label: "Examen", icon: ScrollText, to: "/examen", match: (p) => p.startsWith("/examen") },
  { id: "contacto", label: "Contacto", icon: Phone, to: "/#contacto", match: (p) => false },
];

export default function MobileBottomNav() {
  const { pathname, hash } = useLocation();
  const [active, setActive] = useState("inicio");

  useEffect(() => {
    // pick first matching item
    const found = ITEMS.find((it) => it.match(pathname));
    if (hash === "#contacto") setActive("contacto");
    else setActive(found ? found.id : "inicio");
  }, [pathname, hash]);

  return (
    <nav
      data-testid="mobile-bottom-nav"
      aria-label="Navegación rápida"
      className="fixed bottom-0 inset-x-0 z-40 sm:hidden bg-white/95 backdrop-blur border-t border-[rgba(30,42,143,0.12)] pb-[env(safe-area-inset-bottom)] shadow-[0_-4px_16px_rgba(30,42,143,0.08)]"
    >
      <ul className="grid grid-cols-5 max-w-md mx-auto">
        {ITEMS.map((it) => {
          const Icon = it.icon;
          const isActive = active === it.id;
          return (
            <li key={it.id}>
              <Link
                to={it.to}
                data-testid={`mobile-nav-${it.id}`}
                className={`flex flex-col items-center gap-0.5 py-2.5 transition-colors ${
                  isActive ? "text-[var(--faro-red)]" : "text-[var(--faro-text-soft)] hover:text-[var(--faro-blue)]"
                }`}
              >
                <Icon size={20} strokeWidth={isActive ? 2.5 : 2} />
                <span className={`text-[10px] font-bold uppercase tracking-wider ${isActive ? "text-[var(--faro-red)]" : ""}`}>
                  {it.label}
                </span>
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
